import { render } from "./UserInfoPage.vue?vue&type=template&id=addc27d2&scoped=true"
import script from "./UserInfoPage.vue?vue&type=script&lang=js"
export * from "./UserInfoPage.vue?vue&type=script&lang=js"

import "./UserInfoPage.vue?vue&type=style&index=0&id=addc27d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addc27d2"]])

export default __exports__